export default __webpack_public_path__ + "static/media/6.82a0b499.png";